import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, enableIndexedDbPersistence } from "firebase/firestore";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

// Vérification de la configuration avant l'initialisation
if (!firebaseConfig.apiKey || firebaseConfig.apiKey.includes("your_api_key")) {
  console.error(
    "ERREUR DE CONFIGURATION: Les clés Firebase ne sont pas chargées. Vérifiez votre fichier .env."
  );
  // Ne pas initialiser si la clé API est manquante/générique
  throw new Error("Clé Firebase API manquante ou invalide.");
}

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);
export const db = getFirestore(app);

// Activer la persistence IndexedDB et gérer les erreurs de fallback
enableIndexedDbPersistence(db).catch((err) => {
  if (err.code === "failed-precondition") {
    console.warn("Persistence already enabled");
  } else if (err.code === "unimplemented") {
    console.warn("Browser does not support persistence");
  }
});
export default app;
